// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  entityId: __t.u16().primaryKey().name("entity_id"),
  instance: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  facingFlags: __t.u8().name("facing_flags"),
  healthPct: __t.u8().name("health_pct"),
  stamina: __t.i32(),
  staminaDelay: __t.u8().name("stamina_delay"),
  ack: __t.u32(),
  epoch: __t.u8(),
  stun: __t.u8(),
});
